import * as React from 'react';
import { Pressable, View } from 'react-native';
import { createStyleSheet, useStyles } from 'react-native-unistyles';

import { Card, Text } from '@/ui';

interface SubscriptionPeriodItemProps {
  title: string;
  subtitle: string;
  mostPopular: boolean;
  isFreeDelivery: boolean;
  cost: string;
  unit: string;
  style?: any;
  active?: boolean;
  onPress?: () => void;
}

export const SubscriptionPeriodItem = ({
  title,
  subtitle,
  mostPopular,
  isFreeDelivery,
  cost,
  unit,
  style,
  active = false,
  onPress,
}: SubscriptionPeriodItemProps) => {
  const { styles, theme } = useStyles(stylesheet);
  const [hover, setHover] = React.useState(false);

  const getStyle = () => {
    let stateStyle = styles.default;

    if (hover) {
      stateStyle = styles.hover;
    }
    if (active) {
      stateStyle = styles.active;
    }

    return [stateStyle];
  };

  return (
    <Pressable
      style={[styles.container, style]}
      onHoverIn={() => setHover(true)}
      onHoverOut={() => setHover(false)}
      hitSlop={8}
      onPress={() => {
        onPress?.();
      }}
    >
      <Card style={[styles.card, getStyle()]}>
        <View style={styles.cardContentContainer}>
          {mostPopular ? (
            <View>
              <Text
                type="caption1"
                style={{ color: theme.colors.chip.brand.color }}
              >
                Most Popular
              </Text>
            </View>
          ) : null}

          <View
            style={{
              gap: 4,
              flexShrink: 1,
            }}
          >
            <Text type="bodyBold">{title}</Text>

            <Text
              type="caption1"
              style={{ color: theme.colors.text.secondary }}
            >
              {subtitle}
            </Text>

            {isFreeDelivery ? (
              <Text style={{ color: theme.colors.success }} type="caption1">
                Free Delivery up to 10 miles
              </Text>
            ) : null}
          </View>
        </View>

        <View style={styles.cardPricingContainer}>
          <View
            style={{
              flexDirection: 'row',
              gap: 4,
              alignItems: 'center',
            }}
          >
            <Text type="bodyBold">${cost}</Text>

            <Text
              type="caption1"
              style={{ color: theme.colors.text.secondary }}
            >
              /
            </Text>

            <Text
              type="caption1"
              style={{ color: theme.colors.text.secondary }}
            >
              {unit}
            </Text>
          </View>

          <View>
            <Text
              type="caption1"
              style={{ color: theme.colors.text.secondary }}
            >
              + $99 Initiation Fee
            </Text>
          </View>
        </View>
      </Card>
    </Pressable>
  );
};

const stylesheet = createStyleSheet((theme) => ({
  container: {
    width: '100%',
  },
  card: {
    flex: 1,
    flexDirection: {
      xs: 'row',
      md: 'column',
    },
    justifyContent: 'space-between',
    alignItems: {
      xs: 'center',
      md: 'flex-start',
    },
    padding: 16,
    gap: 16,
    borderRadius: 16,
    borderWidth: 1,
  },
  cardContentContainer: {
    flexDirection: {
      xs: 'column',
      md: 'row-reverse',
    },
    flex: 1,
  },
  cardPricingContainer: {
    flexDirection: 'column',
    alignItems: {
      xs: 'flex-end',
      md: 'flex-start',
    },
    gap: 4,
  },
  default: {
    backgroundColor: theme.colors.card.default.backgroundColor,
    borderColor: theme.colors.card.default.borderColor,
  },
  active: {
    backgroundColor: theme.colors.card.active.backgroundColor,
    borderColor: theme.colors.card.active.borderColor,
    borderWidth: 1,
  },
  hover: {
    backgroundColor: theme.colors.card.hover.backgroundColor,
    borderColor: theme.colors.card.hover.borderColor,
  },
}));
